import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Rating,
  Switch,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import IssueItem from '../../components/Issue/IssueItem'
import RootStore from '../../store/RootStore'
import { toastConfig } from '../../helpers/toastConfig'
import './styles/Issue.scss'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import EditIssue from '../../components/modals/EditIssue'
import { Issue } from '../../types/models/Issue'
import { IoVolumeHigh, IoVolumeMute } from 'react-icons/io5'
import CompliteIssueWork from '../../components/modals/CompliteIssueWork'
import AddKeyToUser from '../../components/modals/AddKeyToUser'
import UserSelect from '../../components/AppHeader/UserSelect'
import TextFieldKeyboard from '../../components/forms/TextFieldKeyboard'

const alarm = require('../../static/audio/alarm.wav')

const margin = 'dense'
const variant = 'standard'

type Props = {
  lite?: boolean
}

const IssuesPage = observer((props: Props) => {
  const { lite } = props
  const { isFilterCurrentPath, currentPath, audioOn } = RootStore.userAction
  const issues = RootStore.userAction.issues
  const defaultLocation = RootStore.settingsStore.location

  const [issueId, setIssueId] = React.useState(0)
  const [feedback, setFeedback] = React.useState('')
  const [rating, setRating] = React.useState(5)

  React.useEffect(() => {
    fetchData()
    const timer = setInterval(fetchData, 7000)
    return () => {
      clearInterval(timer)
    }
  }, [])

  const fetchData = async () => {
    if (lite)
      await RootStore.userAction.getNewIssueBySource('Авария')
    else
      await RootStore.userAction.getNewIssue()
  }

  if (!issues)
    return (
      <div className="Home-content">
        <p>Загрузка...</p>
      </div>
    )

  const hundleAccept = (issue: Issue) => {
    if (issue) RootStore.modalsUi.hundleEditIssue(true, issue)
  }

  const hundleComplite = (issue: Issue) => {
    if (issue) RootStore.modalsUi.hundleCompliteIssueWork(true, issue)
  }

  const hundleEnd = (id: number) => {
    setIssueId(id)
  }

  const hundleClose = async () => {
    setFeedback('')
    setRating(5)
    setIssueId(0)
  }
  
  const hundleChange = async () => {
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.endIssue(issueId, { feedback, rating })
      toast.update(toastId, {
        render: 'Успешно',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      setIssueId(0)
      fetchData()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
    }
  }
  const issue = issues.find((issue) => issue.id === issueId)

  return (
    <div className="issue">
      {lite ? (
        <>
          <p className="issue-helperText">По текущему расположению</p>
          <Switch
            checked={isFilterCurrentPath}
            onChange={() => {
              RootStore.userAction.setFilterCurrentPath(!isFilterCurrentPath)
            }}
          />
        </>
      ) : (
        <>
          <div className="issue-volume">
            {audioOn ? (
              <IoVolumeMute
                onClick={() => RootStore.userAction.setMuteAudio(false)}
                size={32}
              />
            ) : (
              <IoVolumeHigh
                onClick={() => RootStore.userAction.setMuteAudio(true)}
                size={32}
              />
            )}
          </div>
          {issues.find((issue) => {
            return !issue.takeTime
          }) ? (
            <audio loop src={alarm} muted={audioOn} autoPlay />
          ) : null}
        </>
      )}

      {issues.length ? (
        issues.map((issue) => {
          if (isFilterCurrentPath && currentPath) {
            if (!issue.locationPath?.includes(currentPath)) {
              // console.log(`currentPath: ${issue.locationPath} != ${currentPath}`)
              return null
            }
          }
          if (
            defaultLocation &&
            !issue.locationPath?.includes(defaultLocation.name)
          ) {
            return null
          }
          return (
            <IssueItem
              key={issue.id}
              issue={issue}
              lite={lite}
              onAccepted={() => {
                hundleAccept(issue)
              }}
              onComplite={() => {
                hundleComplite(issue)
              }}
              onEnd={() => {
                hundleEnd(issue.id)
              }}
            />
          )
        })
      ) : (
        <p className="issue-helperText">Нет заявок ✔</p>
      )}

      <Dialog open={!!issueId} onClose={hundleClose}>
        <DialogTitle>Оценка ...</DialogTitle>
        <div className="issue-modals">
          <DialogContent>
            <UserSelect />
            <TextFieldKeyboard
              label="Отзыв (необязательно)"
              onChange={(event) => setFeedback(event.target.value)}
              multiline
              variant={variant}
              margin={margin}
              rows={3}
              fullWidth
            />
            <div className="issue-modals-rating">
              <Rating
                defaultValue={5}
                max={10}
                precision={1}
                onChange={(event, newValue) => {
                  if (newValue) setRating(newValue)
                }}
                icon={<StarIcon fontSize="inherit" />}
                emptyIcon={<StarBorderIcon fontSize="inherit" />}
              />
              <div className="issue-modals-rating-number">{rating} / 10</div>
            </div>
          </DialogContent>
          {issue ? <IssueItem issue={issue} noAction /> : null}
        </div>

        <DialogActions>
          <Button onClick={hundleChange}>Оценить работу</Button>
          <Button onClick={hundleClose}>Отмена</Button>
        </DialogActions>
      </Dialog>
      <EditIssue />
      <CompliteIssueWork />
      <AddKeyToUser />
    </div>
  )
})

export default IssuesPage
